import { render, staticRenderFns } from "./inactive.vue?vue&type=template&id=2f302666&scoped=true&"
import script from "./inactive.js?vue&type=script&lang=js&"
export * from "./inactive.js?vue&type=script&lang=js&"
import style0 from "../overview.scss?vue&type=style&index=0&id=2f302666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f302666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f302666')) {
      api.createRecord('2f302666', component.options)
    } else {
      api.reload('2f302666', component.options)
    }
    module.hot.accept("./inactive.vue?vue&type=template&id=2f302666&scoped=true&", function () {
      api.rerender('2f302666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Overview/Inactive/inactive.vue"
export default component.exports